<template>
  
</template>

<script>
export default {
  name: "paymentResDpo",
  components: {},
  created(){
       this.doSubscribe()
  },

  methods: {
    doSubscribe() {
      this.$store.commit("setLoader", true);
      this.$store.dispatch("DpoVerifyPayment", {
          subscriptionId:this.$route.query.PnrID,
          transactionId:this.$route.query.TransID,
          transactionToken:this.$route.query.TransactionToken
        })
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            " Subscription Added Sucessfully !! "
          );
          this.$router.push("/home");
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            " Error Occured Please try again  "
          );
          this.$router.push("/packages");
        });
    },
   
  },

   
  data() {
    return {
		data: null,
      checked: false,
	  currentSubs: null,
 	currentpackages: null,
   packages:null
    };
  },
};
</script>
<style scoped>

</style>
